module.exports = __webpack_public_path__ + "static/media/d21ru.0a38fdb4.pdf";